import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import {
  BsEnvelopeFill,
  BsGeoAltFill,
  BsLinkedin,
  BsGithub,
  BsCheckCircleFill,
  BsExclamationCircleFill,
  BsSendFill,
} from "react-icons/bs";


const EMAILJS_SERVICE_ID  = "service_i3s65ob";  
const EMAILJS_TEMPLATE_ID = "template_ity49wq"; 
const EMAILJS_PUBLIC_KEY  = "0Xz2S_DstkevTBUKh";  

const CONTACT_INFO = [
  {
    icon: <BsGeoAltFill />,
    label: "Location",
    value: "Lahore, Punjab, Pakistan",
    href: null,
  },
  {
    icon: <BsEnvelopeFill />,
    label: "Email",
    value: "mrmuaaz31@gmail.com",
    href: "mailto:mrmuaaz31@gmail.com",
  },
  {
    icon: <BsLinkedin />,
    label: "LinkedIn",
    value: "muhammad-muaaz-120237297",
    href: "https://www.linkedin.com/in/muhammad-muaaz-120237297/",
  },
  {
    icon: <BsGithub />,
    label: "GitHub",
    value: "MuhammadMuaaz007",
    href: "https://github.com/MuhammadMuaaz007",
  },
];

const INITIAL = { name: "", email: "", subject: "", message: "" };

function ContactSection() {
  const [fields, setFields]       = useState(INITIAL);
  const [errors, setErrors]       = useState({});
  const [status, setStatus]       = useState("idle"); // idle | sending | success | error
  const [touched, setTouched]     = useState({});
  const [sentName, setSentName]   = useState("");

  /* ── Validation ── */
  function validate(data) {
    const errs = {};
    if (!data.name.trim())                          errs.name    = "Name is required";
    if (!data.email.trim())                         errs.email   = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) errs.email = "Enter a valid email";
    if (!data.subject.trim())                       errs.subject = "Subject is required";
    if (!data.message.trim())                       errs.message = "Message is required";
    else if (data.message.trim().length < 20)       errs.message = "Message must be at least 20 characters";
    return errs;
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setFields((prev) => ({ ...prev, [name]: value }));
    if (touched[name]) {
      const errs = validate({ ...fields, [name]: value });
      setErrors((prev) => ({ ...prev, [name]: errs[name] }));
    }
  }

  function handleBlur(e) {
    const { name } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
    const errs = validate(fields);
    setErrors((prev) => ({ ...prev, [name]: errs[name] }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setTouched({ name: true, email: true, subject: true, message: true });
    const errs = validate(fields);
    setErrors(errs);
    if (Object.keys(errs).length > 0) return;

    setStatus("sending");

    try {
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        {
          from_name:  fields.name,
          from_email: fields.email,
          subject:    fields.subject,
          message:    fields.message,
          to_email:   "mrmuaaz31@gmail.com",
        },
        EMAILJS_PUBLIC_KEY
      );
      setSentName(fields.name);
      setStatus("success");
      setFields(INITIAL);
      setTouched({});
      setErrors({});
    } catch (err) {
      console.error("EmailJS error — status:", err?.status, "| text:", err?.text, err);
      setStatus("error");
    }
  }

  function resetStatus() {
    setStatus("idle");
  }

  return (
    <section id="contact" className="portfolio-section alt">
      <div className="section-container">
        <span className="section-label">Get In Touch</span>
        <h2 className="section-title">
          Contact <span>Me</span>
        </h2>
        <p className="section-subtitle">
          Have a project in mind, a question, or just want to say hi? Drop me a
          message — I'll get back to you within 24 hours.
        </p>
        <div className="section-divider" />

        <div className="contact-grid">
          {/* ── Left: Contact info ── */}
          <div className="contact-info-panel">
            <h3 className="contact-info-heading">Contact Information</h3>
            <p className="contact-info-sub">
              Feel free to reach out through any of these channels.
            </p>

            <div className="contact-info-list">
              {CONTACT_INFO.map(({ icon, label, value, href }) => (
                <div className="contact-info-item" key={label}>
                  <div className="contact-info-icon">{icon}</div>
                  <div>
                    <p className="contact-info-label">{label}</p>
                    {href ? (
                      <a
                        href={href}
                        target="_blank"
                        rel="noreferrer"
                        className="contact-info-value contact-info-link"
                      >
                        {value}
                      </a>
                    ) : (
                      <p className="contact-info-value">{value}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Availability badge */}
            <div className="contact-available-badge">
              <span className="contact-available-dot" />
              Available for new opportunities
            </div>
          </div>

          {/* ── Right: Form ── */}
          <div className="contact-form-panel">
            {status === "success" ? (
              <div className="contact-success-state">
                <BsCheckCircleFill className="contact-success-icon" />
                <h3>Message Sent!</h3>
                <p>
                  Thanks for reaching out{sentName ? `, ${sentName}` : ""}. I'll reply to your email within 24 hours.
                </p>
                <button className="btn-primary-custom" onClick={resetStatus}>
                  Send Another Message
                </button>
              </div>
            ) : (
              <form
                onSubmit={handleSubmit}
                className="contact-form"
                noValidate
              >
                <div className="contact-form-row">
                  <div className="contact-field-group">
                    <label htmlFor="contact-name" className="contact-label">
                      Full Name <span className="contact-required">*</span>
                    </label>
                    <input
                      id="contact-name"
                      type="text"
                      name="from_name"
                      placeholder="Muhammad Muaaz"
                      value={fields.name}
                      onChange={(e) =>
                        handleChange({ target: { name: "name", value: e.target.value } })
                      }
                      onBlur={(e) =>
                        handleBlur({ target: { name: "name" } })
                      }
                      className={`contact-input${errors.name && touched.name ? " contact-input-error" : ""}`}
                      autoComplete="name"
                    />
                    {errors.name && touched.name && (
                      <span className="contact-error-msg">{errors.name}</span>
                    )}
                  </div>

                  <div className="contact-field-group">
                    <label htmlFor="contact-email" className="contact-label">
                      Email Address <span className="contact-required">*</span>
                    </label>
                    <input
                      id="contact-email"
                      type="email"
                      name="from_email"
                      placeholder="you@example.com"
                      value={fields.email}
                      onChange={(e) =>
                        handleChange({ target: { name: "email", value: e.target.value } })
                      }
                      onBlur={(e) =>
                        handleBlur({ target: { name: "email" } })
                      }
                      className={`contact-input${errors.email && touched.email ? " contact-input-error" : ""}`}
                      autoComplete="email"
                    />
                    {errors.email && touched.email && (
                      <span className="contact-error-msg">{errors.email}</span>
                    )}
                  </div>
                </div>

                <div className="contact-field-group">
                  <label htmlFor="contact-subject" className="contact-label">
                    Subject <span className="contact-required">*</span>
                  </label>
                  <input
                    id="contact-subject"
                    type="text"
                    name="subject"
                    placeholder="Project inquiry / Collaboration / Just saying hi"
                    value={fields.subject}
                    onChange={(e) =>
                      handleChange({ target: { name: "subject", value: e.target.value } })
                    }
                    onBlur={(e) =>
                      handleBlur({ target: { name: "subject" } })
                    }
                    className={`contact-input${errors.subject && touched.subject ? " contact-input-error" : ""}`}
                  />
                  {errors.subject && touched.subject && (
                    <span className="contact-error-msg">{errors.subject}</span>
                  )}
                </div>

                <div className="contact-field-group">
                  <label htmlFor="contact-message" className="contact-label">
                    Message <span className="contact-required">*</span>
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    rows={5}
                    placeholder="Tell me about your project or idea..."
                    value={fields.message}
                    onChange={(e) =>
                      handleChange({ target: { name: "message", value: e.target.value } })
                    }
                    onBlur={(e) =>
                      handleBlur({ target: { name: "message" } })
                    }
                    className={`contact-input contact-textarea${errors.message && touched.message ? " contact-input-error" : ""}`}
                  />
                  <div className="contact-char-count">
                    {fields.message.length} chars
                    {errors.message && touched.message && (
                      <span className="contact-error-msg" style={{ marginLeft: 8 }}>
                        {errors.message}
                      </span>
                    )}
                  </div>
                </div>

                {status === "error" && (
                  <div className="contact-alert-error">
                    <BsExclamationCircleFill />
                    Something went wrong. Please try emailing directly at{" "}
                    <a href="mailto:mrmuaaz31@gmail.com">mrmuaaz31@gmail.com</a>
                  </div>
                )}

                <button
                  type="submit"
                  className="btn-primary-custom contact-submit-btn"
                  disabled={status === "sending"}
                >
                  {status === "sending" ? (
                    <>
                      <span className="contact-spinner" /> Sending…
                    </>
                  ) : (
                    <>
                      <BsSendFill /> Send Message
                    </>
                  )}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
